import { FC } from 'react'

import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { endpoints } from 'modules/endpoints'
import { TableFiltersProps } from 'modules/types'
import { useTranslation } from 'react-i18next'
import { AClearFiltersButton } from 'views/components/Analytics'
import { FiltersAndSearchWrapper, FiltersWrapper } from 'views/components/CommonTableComponents/CommonTableComponents'
import { SearchFilter } from 'views/components/SearchFilter/SearchFilter'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { ADateRangePicker } from 'views/components/TableFilters/DateRangePicker/ADateRangePicker'
import { NewTeamFilter } from 'views/components/TeamFilter/NewTeamFilter'
import { TaskStatus } from 'modules/domain/task/types'

export const tasksDefaultListFilter = {
  status: [TaskStatus.new, TaskStatus.in_progress],
}

export const TasksFilters: FC<TableFiltersProps> = ({ setListRequestParams, updateFilterState, listRequestParams }) => {
  const { t } = useTranslation('my_tasks')

  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
    defaultFilters: tasksDefaultListFilter,
  })

  return (
    <FiltersAndSearchWrapper>
      <FiltersWrapper>
        <ADateRangePicker
          value={[listRequestParams.filter.created_after, listRequestParams.filter.created_before]}
          onChange={(value) => updateFilterState({ created_after: value.startDate, created_before: value.endDate })}
          id="dateFilter"
        />
        <ABaseTableFilter
          onChange={(task_type) => updateFilterState({ task_type })}
          endpoint={endpoints.typesTask('my-tasks')}
          value={listRequestParams.filter.task_type}
          placeholder={t('placeholders.type_task')}
          getLabel={(obj) => obj.label}
          searchField="search"
          showSearch={false}
          simpleApiFormat
          id="typeFilter"
        />
        <ABaseTableFilter
          onChange={(status) => updateFilterState({ status })}
          endpoint={endpoints.tasksStatuses()}
          value={listRequestParams.filter.status}
          placeholder={t('placeholders.status')}
          getLabel={(dto) => dto.label}
          showSearch={false}
          simpleApiFormat
          id="statusFilter"
          multiple
        />
        <ABaseTableFilter
          onChange={(created_by) => updateFilterState({ created_by })}
          value={listRequestParams.filter.created_by}
          placeholder={t('placeholders.author')}
          getLabel={(label) => label.full_name}
          endpoint={endpoints.coordinatorsShort()}
          searchField="search"
          id="authorFilter"
        />
        <ABaseTableFilter
          onChange={(assignee) => updateFilterState({ assignee })}
          value={listRequestParams.filter.assignee}
          placeholder={t('placeholders.executor')}
          getLabel={(label) => label.full_name}
          endpoint={endpoints.taskAssignees()}
          searchField="search"
          simpleApiFormat
          id="assigneeFilter"
        />
        <NewTeamFilter
          eventId="teamsFilter"
          value={listRequestParams.filter.team}
          updateFilterState={updateFilterState}
        />
        <ABaseTableFilter
          onChange={(linked_user_company) => updateFilterState({ linked_user_company })}
          value={listRequestParams.filter.linked_user_company}
          placeholder={t('placeholders.company')}
          id="companyFilter"
          endpoint={endpoints.company()}
          getLabel={(dto) => dto.name}
          searchField="search"
        />
        <ABaseTableFilter
          onChange={(priority) => updateFilterState({ priority })}
          value={listRequestParams.filter.priority}
          placeholder={t('placeholders.priority')}
          endpoint={endpoints.priorityTask()}
          getLabel={(label) => label.label}
          showSearch={false}
          simpleApiFormat
          id="priorityFilter"
        />
        {displayClearBtn && (
          <AClearFiltersButton
            onClick={() =>
              setListRequestParams &&
              setListRequestParams({ ...defaultListRequestParams, filter: { ...tasksDefaultListFilter } })
            }
          />
        )}
      </FiltersWrapper>
      <SearchFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
    </FiltersAndSearchWrapper>
  )
}
